<div id="wadc-container" class="toro-component-shield-host" [ngClass]="{'is-selected': isSelected && !isMobile, 'is-mobile': isMobile}">
    <div id="wadc-label" class="prevent-select">{{datum.label | translate}}</div>
    <div id="wadc-value" class="prevent-select" [ngStyle]="{color: datum?.color}">{{datum.value}}<span id="wadc-units" [ngClass]="{'is-metric': datum?.isMetric}">{{datum?.units}}</span></div>
    <toro-component-shield (shieldClick)="onSelect()"></toro-component-shield>
</div>
